/* Lilla Guldfågeln: the site shell (assets/lg.js), ported from the design prototype's script
   (lilla-guldfageln/index.html). Plain ES2019, no build step; loaded deferred on every page, before lg-3d.js
   and the page scripts (lg-home.js, lg-product.js), so window.LG is ready when they run.

   It reads the JSON islands into window.LG and runs the shell:
   - header: mega menus, the phone menu, the search overlay (Shopify predictive search)
   - the AJAX cart drawer: line totals, the engraving fee product, the free-shipping meter, Shopify's checkout
   - toast, copy buttons, opening hours, gold flash links, the announcement rotator, the lamp spotlight
   - panels (cart, menu, search, the product page's photo viewer): while one is open the page behind is inert,
     so focus stays in the panel, and it returns to the button that opened it.

   Public (window.LG):
     LG.products, LG.cols, LG.assets, LG.settings    from the islands (snippets/lg-data.liquid) and the cards' data-lg
     LG.cart.add(handleOrVariantId, qty, properties)  -> Promise of the cart. properties {Gravyr, Gravyrstil} also add
                                                      the engraving fee product (theme setting) with {Till: title}.
                                                      A handle alone is refused for a product with several variants.
     LG.cart.open(), LG.cart.refresh(), LG.cart.get()
     LG.toast(text), LG.openPanel(el), LG.closePanel(), LG.closeAll(), LG.flash(key)
     LG.hydrate(root)   registers the cards in root and asks lg-3d.js for their studio renders (the engine loads
                        when the first stand comes near the screen); LG.engine() -> Promise of window.LG3D
     LG.card(p), LG.title(p), LG.hallmark(p), LG.stamp(metal), LG.money(cents), LG.fmt(kr), LG.esc(s), LG.sized(url, w)
     LG.COLS (names, metal, group, gift flag; counts from Liquid), LG.GROUPS, LG.DOP, LG.SHORT, LG.colFor(group, metal)
     LG.load(name)      a JSON asset from LG.assets (specs, facts), fetched once
     LG.updateOpen(), LG.REDUCED, LG.FINE, LG.icons
   Events: 'lg:open' and 'lg:close' on a panel, 'lg:cart' on document (detail: the cart), 'lg:metal' on document
   (detail: 'guld' | 'silver'). [data-add] buttons are bought here; call e.preventDefault() in your own click
   handler to take one over. */
(function(){
'use strict';

const $ = (s, el) => (el || document).querySelector(s);
const $$ = (s, el) => Array.prototype.slice.call((el || document).querySelectorAll(s));
const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const FINE = matchMedia('(pointer: fine)').matches;
const ICON_ARR = '<svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const ICON_PLUS = '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>';
const SHARD = '<svg viewBox="0 0 12 12"><path d="M6 0l6 6-6 6-6-6z"/></svg>';

/* ---------- data: the JSON islands ---------- */
const LG = window.LG = window.LG || {};
LG.products = LG.products || {};
function register(list){
  (Array.isArray(list) ? list : Object.keys(list || {}).map(k => list[k])).forEach(p => {
    if (p && p.h && !LG.products[p.h]) LG.products[p.h] = p;
  });
}
// #lg-data and script[data-lg-data] hold {products, …}; script[data-lg-products] holds a plain {handle: entry} map
function readIslands(root){
  $$('script#lg-data, script[data-lg-data], script[data-lg-products]', root).forEach(s => {
    if (s._lg) return; s._lg = 1;
    let d; try { d = JSON.parse(s.textContent) } catch(e) { return }
    if (!d) return;
    if (s.hasAttribute('data-lg-products')) { register(d); return }
    if (d.products) register(d.products);
    ['cols', 'assets', 'settings'].forEach(k => { if (d[k]) LG[k] = Object.assign(LG[k] || {}, d[k]) });
  });
}
// every card carries its own product entry (snippets/lg-card.liquid)
function collect(root){
  $$('[data-lg]', root).forEach(el => {
    if (el._lg) return; el._lg = 1;
    try { register([JSON.parse(el.getAttribute('data-lg'))]) } catch(e) {}
  });
}
readIslands(); collect();
const S = LG.settings = Object.assign({free:1999, ship:199, money:'{{amount}} kr', eng:null, hours:{}, routes:{}}, LG.settings || {});
const R = Object.assign({root:'/', cart:'/cart', cart_add:'/cart/add', cart_change:'/cart/change', cart_update:'/cart/update', search:'/search', suggest:'/search/suggest'}, S.routes || {});
const ROOT = /\/$/.test(R.root) ? R.root : R.root + '/';

/* ---------- the shop's categories (the prototype's COLS; counts from Liquid) ---------- */
const COLS = {
  'vara-favoriter':{n:'Våra favoriter'},
  guldarmband:{n:'Guldarmband',m:'guld',g:'armband'}, silverarmband:{n:'Silverarmband',m:'silver',g:'armband'},
  guldhalsband:{n:'Guldhalsband',m:'guld',g:'halsband'}, silverhalsband:{n:'Silverhalsband',m:'silver',g:'halsband'},
  guldringar:{n:'Guldringar',m:'guld',g:'ringar'}, silverringar:{n:'Silverringar',m:'silver',g:'ringar'},
  guldorhange:{n:'Guldörhängen',m:'guld',g:'orhangen'}, silverorhangen:{n:'Silverörhängen',m:'silver',g:'orhangen'},
  guldberlock:{n:'Guldberlocker',m:'guld',g:'berlocker'}, silverberlock:{n:'Silverberlocker',m:'silver',g:'berlocker'},
  bestick:{n:'Bestick',d:1}, muggar:{n:'Muggar',d:1}, flaggor:{n:'Flaggor & flaggstänger',d:1},
  fotoalbum:{n:'Fotoalbum',d:1}, termos:{n:'Termos',d:1}, tallrikar:{n:'Tallrikar',d:1},
  klockor:{n:'Klockor'}
};
Object.keys(COLS).forEach(k => { COLS[k].c = +((LG.cols || {})[k]) || 0 });
const DOP = ['muggar','bestick','fotoalbum','termos','flaggor','tallrikar'].filter(k => COLS[k].c);   // empty gift categories stay out of the menus
const GROUPS = [['armband','Armband'],['halsband','Halsband'],['ringar','Ringar'],['orhangen','Örhängen & nässmycken'],['berlocker','Berlocker']];
const SHORT = {orhangen:'Örhängen'};
const colFor = (g, m) => Object.keys(COLS).find(k => COLS[k].g === g && COLS[k].m === m);
const metalOf = col => (COLS[col] && COLS[col].m) || null;
// a favourite listed only under Våra favoriter belongs to its own category
const GUESS = {guldring:'guldringar',silverring:'silverringar',guldhalsband:'guldhalsband',silverhalsband:'silverhalsband',guldarmband:'guldarmband',silverarmband:'silverarmband',guldorhange:'guldorhange',silverorhange:'silverorhangen',guldberlock:'guldberlock',silverberlock:'silverberlock'};
const guessCol = h => { const k = Object.keys(GUESS).find(x => String(h).indexOf(x) === 0); return k ? GUESS[k] : null };

// Swedish names for listings the shop imported in English. Since 2026-10-11 the listings themselves carry these names, so this only
// matters for data cached from before the rename
const SV = {
 'creative-compact-minimalist-waterproof-digital-watch':'Minimalistisk digital klocka, vattentät',
 'square-calendar-watches-for-men-and-women':'Fyrkantig klocka med datum',
 'mechanical-watches-mens-mechanical-watches':'Mekanisk herrklocka',
 'bobo-bird-engraving-men-watches-family-gifts-for-son-dad-mom-mens-quartz-women-wristwatch-for-boyfriend-engrave-d26':'Bobo Bird träklocka med gravyr',
 'digital-mens-watch-women-watch-sport-digital-wrist-watch-for-luxury-men-watches':'Digital sportklocka',
 'quartz-watches-for-men-and-women-1':'Kvartsklocka unisex',
 'led-luminous-watches-geneva-women-quartz-watch-women-ladies-silicone-bracelet-watches':'LED-klocka med silikonarmband',
 'fashion-women-watches-leather-quartz-watch-for-ladies-clocks':'Damklocka med läderarmband',
 'retro-mens-six-pointed-star-stainless-steel-oil-surface-ring':'Herrring Stjärna, rostfritt stål',
 'vildmark':'Vildmark',
 'guldring-blue-topas-kz':'Guldring Blå topas med KZ',
 'guldberlock-id-bricka':'Guldberlock ID-bricka',
 'silverberlock-id-bricka':'Silverberlock ID-bricka, 13 × 19 mm',
 'silverberlock-id-bricka-1':'Silverberlock ID-bricka, 17 × 23 mm',
 'guldring-kz-1':'Guldring KZ, öppen med två stenar',
 'guldring-kz':'Guldring KZ, dubbel med stenrad',
 'guldring-fac':'Guldring Facetterad',
 'barnmugg-dop-slat':'Barnmugg Dop, slät, 6,3 cm',
 'barnmugg-dop-slat-1':'Barnmugg Dop, slät, 5,5 cm',
 'barnmugg-nalle-1':'Barnmugg Nalle i tenn',
 'barnmugg-nalle':'Barnmugg Nalle i rostfritt stål',
 'cordellkedja-i-18k-guld':'Cordellkedja i 18 K guld',
 'collier-18k-2f-cz-2hjartan':'Collier Två hjärtan, tvåfärgat 18 K guld med KZ'
};
// pieces with a plain surface made for engraving (the prototype's ENGRAVE map; the card shows a badge)
const ENGRAVABLE = ['barnmugg-dop-slat','barnmugg-dop-slat-1','barnmugg-dop-1','guldberlock-id-bricka','silverberlock-id-bricka','silverberlock-id-bricka-1','guldberlock-hjarta'];

const title = p => (p && (SV[p.h] || p.t)) || '';
// a piece's hallmark: its metal, or 925 when a gift's own listing says sterling silver
const hallmark = p => (p && (p.m || p.hm)) || null;
const stamp = m => m === 'guld' ? '<span class="stamp">750</span>' : m === 'silver' ? '<span class="stamp ag">925</span>' : '';

/* ---------- money: Swedish kronor as snippets/lg-money.liquid writes them ("6 899 kr", "209,52 kr", \u00f6re only when
   there are any, no-break spaces); another currency follows the shop's own money format ---------- */
function money(cents){
  const f = String(S.money || '{{amount}} kr').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '\u00a0').replace(/&amp;/g, '&');
  const n = Math.round(+cents || 0);
  if (!S.cur || S.cur === 'SEK') {
    const a = Math.abs(n), ore = a % 100;
    return (n < 0 ? '\u2212' : '') + String(Math.floor(a / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + (ore ? ',' + String(ore).padStart(2, '0') : '') + '\u00a0kr';
  }
  const num = (dec, th, sep) => {
    const parts = (Math.abs(n) / 100).toFixed(dec).split('.');
    const i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return (n < 0 ? '-' : '') + (parts[1] ? i + sep + parts[1] : i);
  };
  const ways = {
    amount: () => num(2, ',', '.'),
    amount_no_decimals: () => num(0, ',', '.'),
    amount_with_comma_separator: () => num(2, '.', ','),
    amount_no_decimals_with_comma_separator: () => num(0, '.', ','),
    amount_with_apostrophe_separator: () => num(2, "'", '.'),
    amount_no_decimals_with_space_separator: () => num(0, ' ', ','),
    amount_with_space_separator: () => num(2, ' ', ','),
    amount_with_period_and_space_separator: () => num(2, ' ', '.')
  };
  return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (ways[k] || ways.amount)());
}
const fmt = kr => money(Math.round((+kr || 0) * 100));

/* ---------- cards ---------- */
// a Shopify CDN image at a given width
function sized(u, w){
  if (!u) return '';
  u = String(u).replace(/^\/\//, 'https://');
  try { const x = new URL(u, location.href); x.searchParams.set('width', w); return x.href } catch(e) { return u }
}
// the same markup as snippets/lg-card.liquid, for cards made in the browser (search results): the quick-buy button
// sits next to the link (div.qbox lies over the stand), and only products without a choice of variants get one
function card(p){
  const t = title(p), hm = hallmark(p), img = p.img;
  const srcset = img ? [360, 480, 600, 800].map(w => `${esc(sized(img, w))} ${w}w`).join(', ') : '';
  const quick = p.avail !== false && !(p.vn > 1);
  return `<div class="cardw"><a class="card" href="${esc(p.url)}"><div class="pl stand" data-h="${esc(p.h)}">${stamp(hm)}${img ? `<img class="cut" loading="lazy" src="${esc(sized(img, 600))}" srcset="${srcset}" sizes="(max-width: 520px) 46vw, (max-width: 1080px) 30vw, 300px" alt="${esc(t)}">` : ''}<img class="studio" alt="" width="720" height="900">${ENGRAVABLE.indexOf(p.h) > -1 ? '<span class="eng-badge">Gravyr</span>' : ''}</div>
    <span class="t">${esc(t)}</span><span class="pr num">${p.pv ? 'Från ' : ''}${esc(p.pf || fmt(p.p))}${p.avail === false ? ' · Slutsåld' : ''}</span></a>
    ${quick ? `<div class="qbox"><button class="quick" type="button" data-add="${esc(p.h)}"${p.v ? ` data-variant="${esc(p.v)}"` : ''} aria-label="Lägg ${esc(t)} i varukorgen">${ICON_PLUS}<span>Köp</span></button></div>` : ''}</div>`;
}
/* the 3D engine (assets/lg-3d.js) loads when the first stand comes near the screen; it then loads three.js itself
   and renders every stand on the page, including the ones added later. Without it the shop's photos stay. */
let engineP = null;
function engine(){
  if (window.LG3D) return Promise.resolve(window.LG3D);
  if (!engineP) engineP = new Promise((res, rej) => {
    const url = (LG.assets || {}).engine;
    let s = $$('script[src]').find(x => /\/lg-3d\.js/.test(x.src));
    if (!s && !url) { rej(new Error('no 3D engine')); return }
    if (!s) { s = document.createElement('script'); s.src = url; s.async = true; document.head.appendChild(s) }
    s.addEventListener('load', () => window.LG3D ? res(window.LG3D) : rej(new Error('no 3D engine')));
    s.addEventListener('error', () => rej(new Error('no 3D engine')));
    // a tag another script added may have run (or failed) before we listened: decide by what is there
    setTimeout(() => window.LG3D ? res(window.LG3D) : rej(new Error('no 3D engine')), 45000);
  });
  return engineP;
}
const nearIO = 'IntersectionObserver' in window ? new IntersectionObserver(es => {
  if (!es.some(e => e.isIntersecting)) return;
  nearIO.disconnect();
  engine().then(E => E.hydrate(document)).catch(() => {});
}, {rootMargin:'600px'}) : null;
// studio renders for the cards in root (registers their products first)
function hydrate(root){
  root = root || document;
  readIslands(root); collect(root);
  const E = window.LG3D;
  if (E && typeof E.hydrate === 'function') {
    try { E.hydrate(root) } catch(e) { if (window.console) console.warn('LG3D.hydrate', e) }
    return;
  }
  if (nearIO) $$('.stand[data-h]', root).forEach(el => nearIO.observe(el));
}
// JSON assets (lg-specs.json, lg-facts.json), fetched once
const LOADS = {};
function load(name){
  if (!LOADS[name]) {
    const url = (LG.assets || {})[name];
    LOADS[name] = url ? fetch(url).then(r => r.ok ? r.json() : {}).catch(() => ({})) : Promise.resolve({});
  }
  return LOADS[name];
}

/* ---------- toast ---------- */
function toast(t){
  const el = $('#toast'); if (!el) return;
  el.textContent = t; el.hidden = false;
  clearTimeout(toast.t); toast.t = setTimeout(() => { el.hidden = true }, 2200);
}

/* ---------- panels: cart, phone menu, search, photo viewer ----------
   The page behind is inert while one is open (focus stays in the panel), and focus returns to the button that opened it. */
const scrim = $('#scrim');
let openEl = null, lastOpener = null, inerted = [], viaKeys = false;
document.addEventListener('keydown', () => { viaKeys = true }, true);
document.addEventListener('pointerdown', () => { viaKeys = false }, true);
function inertAround(el){
  inerted = [];
  for (let n = el; n && n.parentElement && n !== document.body; n = n.parentElement) {
    Array.prototype.forEach.call(n.parentElement.children, s => {
      if (s === n || s.inert || s === scrim || s.id === 'toast' || /^(SCRIPT|STYLE|LINK|META|TITLE|TEMPLATE|NOSCRIPT)$/.test(s.tagName)) return;
      s.inert = true; inerted.push(s);
    });
  }
}
function openPanel(el){
  if (!el) return;
  const op = document.activeElement;
  closeAll();
  lastOpener = op; openEl = el;
  el.hidden = false;
  if (scrim) scrim.hidden = false;
  document.body.style.overflow = 'hidden';
  inertAround(el);
  if (el.id === 'cart') renderCart();
  if (el.id === 'mmenu') { const b = $('#menuBtn'); if (b) b.setAttribute('aria-expanded', 'true') }
  el.dispatchEvent(new CustomEvent('lg:open', {bubbles:true}));
  // opened from the keyboard, focus moves into the panel (unless the panel's own code placed it, as the search
  // field does); after a click or tap the next Tab lands in the panel anyway, since the page behind is inert
  setTimeout(() => {
    if (!viaKeys || openEl !== el || el.contains(document.activeElement)) return;
    const f = el.querySelector('[data-close]') || el.querySelector('a[href],button,input');
    if (f) f.focus({preventScroll:true});
  }, 60);
}
function closeAll(){
  const was = openEl;
  $$('[data-panel]').concat(was ? [was] : []).forEach(p => { p.hidden = true });
  const lb = $('#lightbox'); if (lb) lb.hidden = true;
  if (scrim) scrim.hidden = true;
  document.body.style.overflow = '';
  inerted.forEach(n => { n.inert = false }); inerted = [];
  openEl = null;
  const b = $('#menuBtn'); if (b) b.setAttribute('aria-expanded', 'false');
  closeMega();
  if (was) was.dispatchEvent(new CustomEvent('lg:close', {bubbles:true}));
}
function closePanel(){
  const o = lastOpener, was = openEl;
  lastOpener = null; closeAll();
  if (was && o && o.focus && document.contains(o)) o.focus();
}

/* ---------- mega menus (rendered by sections/lg-header.liquid) ---------- */
let megaKey = null;
function closeMega(){
  if (!megaKey) return;
  megaKey = null;
  $$('[data-mega-panel]').forEach(p => { p.hidden = true });
  $$('[data-mega]').forEach(b => b.setAttribute('aria-expanded', 'false'));
}
function openMega(k){
  megaKey = k;
  $$('[data-mega-panel]').forEach(p => { p.hidden = p.getAttribute('data-mega-panel') !== k });
  $$('[data-mega]').forEach(b => b.setAttribute('aria-expanded', String(b.getAttribute('data-mega') === k)));
  updateOpen();
}

/* ---------- search: Shopify predictive search ---------- */
// a few shop words people search for (the listings carry Swedish names since 2026-10-11, so "klocka" finds the watches itself)
const SYN = {dopmugg:'barnmugg',dopmuggar:'barnmugg','925':'silver','750':'guld','18k':'guld'};
const POPULAR = ['Hjärta','Pansar','Creol','Bismarck','Barnmugg','ID-bricka'];
const q = $('#q'), qres = $('#qres');
const popular = () => `<span class="eyebrow">Populärt</span><div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:12px">${POPULAR.map(t => `<button class="chip" type="button" data-q="${t}">${t}</button>`).join('')}</div>`;
let sTimer = 0, sCtl = null, sSeq = 0;
function openSearch(){
  openPanel($('#search'));
  if (!q) return;
  q.value = ''; search();
  setTimeout(() => q.focus(), 30);
}
function search(){
  if (!q || !qres) return;
  const raw = q.value.trim();
  clearTimeout(sTimer);
  if (!raw) { sSeq++; if (sCtl) sCtl.abort(); qres.innerHTML = popular(); return }
  sTimer = setTimeout(() => runSearch(raw), 160);
}
// a predictive-search product as an LG product (the price comes in kronor, as text)
function fromSuggest(r){
  const known = LG.products[r.handle]; if (known) return known;
  const price = parseFloat(r.price) || 0;
  const vs = r.variants || [], v = vs.find(x => x.available) || vs[0];
  const img = (r.featured_image && r.featured_image.url) || r.image || null;
  const col = guessCol(r.handle) || (/klock|watch/i.test((r.type || '') + ' ' + r.handle) ? 'klockor' : null);
  const m = metalOf(col) || (/^guld/i.test(r.title) ? 'guld' : /^silver/i.test(r.title) ? 'silver' : null);
  const hm = m || (col !== 'klockor' && /925/.test(r.body || '') ? 'silver' : null);   // some watch listings mention 925 for other reasons
  // vn: how many variants (several: no quick buy, the variant is chosen on the product page); pv: "Från" price
  return {h:r.handle, t:SV[r.handle] || r.title, p:price, pf:fmt(price), url:r.url, img:img ? sized(img, 1200) : null, col:col, m:m, hm:hm,
    avail:r.available !== false, v:v ? v.id : null, vn:vs.length || 1, pv:parseFloat(r.price_max) > parseFloat(r.price_min)};
}
function runSearch(raw){
  const term = SYN[raw.toLowerCase()] || raw, seq = ++sSeq;
  if (sCtl) sCtl.abort();
  sCtl = 'AbortController' in window ? new AbortController() : null;
  // the tags are searched too (51 watches carry "Dam klockor"); Shopify's default fields leave them out
  const url = R.suggest + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
  fetch(url, {headers:{Accept:'application/json'}, signal:sCtl ? sCtl.signal : undefined})
    .then(r => r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)))
    .then(d => {
      if (seq !== sSeq) return;
      // archived CJ products (tag cj-borttagen, 2026-11-02) can linger in Shopify's search index
      const list = ((((d || {}).resources || {}).results || {}).products || []).filter(p => !(p.tags || []).includes('cj-borttagen'));
      const hits = list.map(fromSuggest);
      register(hits);
      const all = allHits(term);
      qres.innerHTML = hits.length
        ? `<span class="eyebrow num">${hits.length} ${hits.length === 1 ? 'träff' : 'träffar'}</span><div class="grid" style="margin-top:16px">${hits.map(card).join('')}</div>${hits.length >= 10 ? `<p class="note">Visar de 10 första träffarna. Skriv fler bokstäver för att hitta rätt, eller <a class="link" href="${esc(all)}">visa alla träffar</a>.</p>` : ''}`
        : `<p style="color:var(--muted);margin-bottom:24px">Inga träffar på ”${esc(raw)}”. Prova ett annat ord eller fråga oss i butiken.</p>${popular()}`;
      hydrate(qres);
    })
    .catch(err => {
      if ((err && err.name === 'AbortError') || seq !== sSeq) return;
      qres.innerHTML = `<p style="color:var(--muted);margin-bottom:24px">Sökningen svarar inte just nu. Tryck Enter för att söka i hela butiken.</p>${popular()}`;
    });
}
// the full results for a term
const allHits = term => R.search + '?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last';
if (q) {
  q.addEventListener('input', search);
  q.form && q.form.addEventListener('submit', e => {
    const raw = q.value.trim();
    if (!raw) { e.preventDefault(); return }
    const term = SYN[raw.toLowerCase()] || raw;
    q.value = term;
  });
}
if (qres) qres.addEventListener('click', e => {
  const b = e.target.closest('[data-q]');
  if (b) { q.value = b.getAttribute('data-q'); search() }
});

/* ---------- cart: Shopify's AJAX Cart API ----------
   An engraved piece carries properties[Gravyr] and properties[Gravyrstil]. When the theme setting
   engraving_product is set, each engraved piece also brings one fee line (property Till = the piece's title),
   linked by a hidden _gravyr_id; the drawer shows the fee inside its piece's line, as the prototype did. */
// the drawer is aside#cart (Dawn's cart page has its own form#cart, and the layout leaves the drawer out there)
const cartEl = $('aside#cart'), cartBody = $('#cartBody'), cartFoot = $('#cartFoot');
let CART = null, cartReq = null;
// cut-outs the engine made for the cart's photos (img[data-cut] -> blob: URL), kept for the next redraw
const CUTS = {};
if (cartBody) cartBody.addEventListener('load', e => {
  const im = e.target;
  if (!im || im.tagName !== 'IMG' || !/^blob:/.test(im.src)) return;
  const pl = im.closest('.pl'); if (pl) pl.classList.remove('photo');
  const h = im.getAttribute('data-cut'); if (h) CUTS[h] = im.src;
}, true);
const feeOf = () => (S.eng && S.eng.v ? S.eng : null);
const props = it => it.properties || {};
const isFee = it => { const f = feeOf(); return !!f && (it.variant_id === +f.v || it.product_id === +f.id) };
const engNote = lines => lines.map(s => String(s || '').trim()).filter(Boolean).join(' / ');
function api(url, body){
  const opt = body
    ? {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body), credentials:'same-origin'}
    : {headers:{Accept:'application/json'}, credentials:'same-origin'};
  return fetch(url, opt).then(r => r.json().catch(() => ({})).then(d => {
    if (!r.ok) { const e = new Error(d.description || d.message || 'Något gick fel. Försök igen.'); e.status = r.status; throw e }
    return d;
  }));
}
// the drawer's lines: fee lines fold into their piece; a fee left without its piece shows on its own
function cartLines(){
  const items = (CART && CART.items) || [], fees = {}, pieces = {};
  items.forEach(it => { const id = props(it)._gravyr_id; if (id) (isFee(it) ? fees : pieces)[id] = it });
  return items
    .filter(it => !(isFee(it) && pieces[props(it)._gravyr_id]))
    .map(it => ({it:it, fee:!isFee(it) && props(it)._gravyr_id ? fees[props(it)._gravyr_id] || null : null}));
}
function paintBadge(){
  const b = $('#cartCount'); if (!b || !CART) return;
  const n = cartLines().reduce((a, l) => a + l.it.quantity, 0);
  b.hidden = !n; b.textContent = n;
  // the button's aria-label replaces its content, so the count is in the label too (as lg-header prints it)
  const btn = b.closest('#cartBtn');
  if (btn) btn.setAttribute('aria-label', n ? `Varukorg, ${n} ${n === 1 ? 'vara' : 'varor'}` : 'Varukorg');
}
function pop(){
  const b = $('#cartCount'); if (!b) return;
  b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
}
function setCart(c){
  CART = c; paintBadge();
  if (cartEl && !cartEl.hidden) renderCart();
  document.dispatchEvent(new CustomEvent('lg:cart', {detail:c}));
  return c;
}
// the cart from Shopify; force skips a request already on its way (it may predate a change)
function refresh(force){
  if (cartReq && !force) return cartReq;
  const req = api(R.cart + '.js').then(c => (req === cartReq ? setCart(c) : CART || c)).finally(() => { if (req === cartReq) cartReq = null });
  cartReq = req;
  return req;
}
const clean = o => {
  const r = {};
  Object.keys(o || {}).forEach(k => { const v = o[k]; if (v != null && String(v).trim() !== '') r[k] = String(v).trim() });
  return r;
};
// a handle or a variant id -> {id, t}: the island knows most products, else the product's own .js.
// A handle stands for a product only when there is nothing to choose: with several variants (lengths, colours,
// birth-month stones) the variant is chosen on the product page, so a handle alone never adds the first one.
const CHOOSE = 'Välj variant på produktsidan';
function variantOf(target){
  if (typeof target === 'number' || /^\d+$/.test(String(target))) {
    const id = +target, hit = Object.keys(LG.products).map(k => LG.products[k]).find(p => +p.v === id);
    return Promise.resolve({id:id, t:hit ? title(hit) : null});
  }
  const h = String(target), p = LG.products[h];
  if (p && p.vn > 1) return Promise.reject(new Error(CHOOSE));
  if (p && p.v && p.vn) return Promise.resolve({id:+p.v, t:title(p)});
  return api(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(pj => {
    const vs = pj.variants || [], v = vs.find(x => x.available) || vs[0];
    if (!v) throw new Error('Produkten finns inte längre i webbutiken.');
    if (vs.length > 1) throw new Error(CHOOSE);
    return {id:v.id, t:SV[h] || pj.title};
  });
}
function add(target, qty, properties){
  const n = Math.max(1, Math.min(99, parseInt(qty, 10) || 1));
  const pr = clean(properties);
  const addUrl = R.cart_add + '.js';
  return variantOf(target).then(v => {
    const fee = pr.Gravyr ? feeOf() : null;
    if (!fee) return api(addUrl, {items:[{id:v.id, quantity:n, properties:pr}]});
    const tag = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    const piece = {id:v.id, quantity:n, properties:Object.assign({}, pr, {_gravyr_id:tag})};
    const feeLine = t => ({id:+fee.v, quantity:n, properties:{Till:t || 'Graverad vara', _gravyr_id:tag}});
    // when the fee product cannot be added (sold out, removed) the piece goes in alone,
    // and the cart says that the shop adds the engraving.
    // The fee is sent first: Shopify lists the newest line first, so the piece is listed above its fee on the cart
    // page (the drawer pairs them by _gravyr_id in any order). A variant chosen on the product page names that page's
    // product. Should Shopify have taken the fee but refused the piece, the lone fee is taken out again.
    const pg = $('[data-lg-product][data-h]'), t = v.t || (pg && LG.products[pg.dataset.h] ? title(LG.products[pg.dataset.h]) : '');
    const tidy = () => api(R.cart + '.js').then(c => {
      const mine = ((c && c.items) || []).filter(it => props(it)._gravyr_id === tag), lone = mine.find(isFee);
      return lone && !mine.some(it => !isFee(it)) ? api(R.cart_update + '.js', {updates:{[lone.key]:0}}) : null;
    }).catch(() => {});
    if (t) return api(addUrl, {items:[feeLine(t), piece]}).catch(() => tidy().then(() => api(addUrl, {items:[{id:v.id, quantity:n, properties:pr}]})));
    return api(addUrl, {items:[piece]}).then(r => {
      const it = (r.items || [])[0] || {};
      return api(addUrl, {items:[feeLine(SV[it.handle] || it.product_title)]}).catch(() => r);
    });
  }).then(() => refresh(true)).then(c => { pop(); return c },
    // Shopify may have added part of the request before it refused the rest (more than the stock): the badge and the
    // drawer show what the cart really holds, and the caller still gets the error for its message
    err => refresh(true).catch(() => {}).then(() => { throw err }));
}
function openCart(){ openPanel(cartEl); refresh().catch(() => {}) }

// the listed price of engraving from lg-facts.json, when the cart has engraving without the fee product
let FACTS = null, factsWait = false;
function knownFee(lines){
  if (!FACTS) {
    if (!factsWait) { factsWait = true; load('facts').then(f => { FACTS = f || {}; if (cartEl && !cartEl.hidden) renderCart() }) }
    return 0;
  }
  for (const l of lines) {
    if (props(l.it).Gravyr && !l.fee) { const g = +((FACTS[l.it.handle] || {}).gravyr) || 0; if (g) return g }
  }
  return 0;
}
function renderCart(){
  if (!cartBody || !cartFoot) return;
  if (!CART) {
    refresh().catch(() => { cartBody.innerHTML = '<p style="padding:40px 0;text-align:center;color:var(--muted)">Varukorgen kunde inte laddas. Ladda om sidan och försök igen.</p>' });
    return;
  }
  const lines = cartLines();
  if (!lines.length) {
    cartBody.innerHTML = `<div style="padding:40px 0;text-align:center;display:grid;gap:14px;justify-items:center"><img src="${esc((LG.assets || {}).bird || '')}" alt="" style="width:90px;opacity:.9"><p style="font:400 24px/1.2 var(--f-display)">Varukorgen är tom</p><p style="color:var(--muted)">Börja med våra favoriter.</p><a class="btn ghost" href="${esc(ROOT)}collections/vara-favoriter">Visa favoriter</a></div>`;
    cartFoot.innerHTML = '';
    return;
  }
  cartBody.innerHTML = lines.map(l => {
    const it = l.it, fee = l.fee, pp = props(it), p = LG.products[it.handle] || {};
    const t = SV[it.handle] || p.t || it.product_title;
    const u = it.final_price + (fee ? fee.final_price : 0);      // an engraved line carries the engraving fee on top of the piece
    // the engine cuts out the product's main photo, so a line whose variant has its own photo keeps that photo
    const img = (it.featured_image && it.featured_image.url) || it.image, file = u => String(u || '').split('?')[0].split('/').pop();
    const mainPhoto = !!p.img && file(img) === file(p.img), cut = mainPhoto ? CUTS[it.handle] : null;
    const vt = it.product_has_only_default_variant || !it.variant_title || /^(standard|default)$/i.test(it.variant_title) ? '' : it.variant_title;
    // the shop's photo on a plate; with the 3D engine on the page it becomes a cut-out on velvet, as in the prototype
    const pic = cut ? `<img class="cut" src="${esc(cut)}" alt="">` : img ? `<img class="cut" src="${esc(sized(img, 200))}" alt=""${mainPhoto ? ` data-cut="${esc(it.handle)}"` : ''}>` : '';
    return `<div class="line" data-key="${esc(it.key)}"${fee ? ` data-fee="${esc(fee.key)}"` : ''}><div class="pl pallet${cut ? '' : ' photo'}">${pic}</div>
    <div><div class="t"><a href="${esc(it.url)}">${esc(t)}</a></div>${vt ? `<div class="vt">${esc(vt)}</div>` : ''}${isFee(it) && pp.Till ? `<div class="vt">Till: ${esc(pp.Till)}</div>` : ''}${pp.Gravyr ? `<div class="eng-note">Gravyr${fee ? ` (+${money(fee.final_price)})` : ''}: ${String(pp.Gravyr).split(' / ').map(s => `<span>${esc(s)}</span>`).join(' / ')}</div>` : ''}<div class="num" style="font-weight:600;font-size:14.4px;margin-top:4px">${it.quantity > 1 ? `${money(u * it.quantity)} <small style="font-weight:400;color:var(--muted)">(${it.quantity} × ${money(u)})</small>` : money(u)}</div><button class="rm" type="button" data-act="rm">Ta bort</button></div>
    <div class="qty"><button type="button" data-act="dec" aria-label="Minska">−</button><span>${it.quantity}</span><button type="button" data-act="inc" aria-label="Öka"${it.quantity >= 9 ? ' disabled' : ''}>+</button></div></div>`;
  }).join('');
  // supplier lines (SKU CJ…) ship free from the supplier in 2–3 weeks. A cart of only those ships free; otherwise Shopify's
  // limit counts the whole order (own pieces and supplier lines together), as the cart's shipping estimate shows
  const fromSupplier = it => /^CJ/i.test(it.sku || ''), own = CART.items.filter(it => !fromSupplier(it)), anySup = own.length < CART.items.length;
  const sum = CART.items_subtotal_price;
  const free = own.length ? Math.round((+S.free || 0) * 100) : 0, left = Math.max(0, free - sum);
  let note = anySup ? '<p class="prototype-msg">Klockor och bijouteri skickas från vår leverantör och levereras inom 2–3 veckor, med fri frakt.</p>' : '';
  if (lines.some(l => props(l.it).Gravyr && !l.fee)) {
    const fee = knownFee(lines);
    note += `<p class="prototype-msg">${fee ? `Gravyren (${fmt(fee)}) läggs till i butiken. Vi kontaktar dig och bekräftar leveranstid innan vi graverar.` : 'Gravyren görs i butiken. Vi bekräftar pris och leveranstid innan vi graverar.'}</p>`;
  }
  cartFoot.innerHTML = `${free ? `<div class="ship-meter"><span>${left ? `Handla för <b class="num">${money(left)}</b> till för fri frakt` : 'Du har fri frakt'}</span><div class="bar"><i style="width:${Math.min(100, sum / free * 100)}%"></i></div></div>` : anySup ? '<div class="ship-meter"><span>Du har fri frakt</span></div>' : ''}
    <div class="sum"><span>Delsumma</span><span class="num">${money(sum)}</span></div>
    ${note}
    <form action="${esc(R.cart)}" method="post"><button class="btn gold full" type="submit" name="checkout">Till kassan</button></form>`;
}
if (cartEl) cartEl.addEventListener('click', e => {
  const t = e.target.closest('[data-act]'); if (!t || !CART) return;
  const line = t.closest('.line'); if (!line) return;
  const key = line.getAttribute('data-key'), fee = line.getAttribute('data-fee'), act = t.getAttribute('data-act');
  const it = CART.items.find(x => x.key === key); if (!it) return;
  const n = Math.max(0, act === 'rm' ? 0 : act === 'inc' ? Math.min(9, it.quantity + 1) : it.quantity - 1);
  const updates = {}; updates[key] = n; if (fee) updates[fee] = n;     // the fee follows its piece
  line.setAttribute('aria-busy', 'true');
  api(R.cart_update + '.js', {updates:updates}).then(c => {
    setCart(c);
    // keep keyboard focus on the same button after the redraw (or on the drawer's close button when the line is gone)
    if (!viaKeys) return;
    const again = $$('.line', cartBody).find(x => x.getAttribute('data-key') === key);
    const b = again && again.querySelector(`[data-act="${act}"]`);
    const to = b && !b.disabled ? b : $('[data-close]', cartEl);
    if (to) to.focus({preventScroll:true});
  }).catch(err => { line.removeAttribute('aria-busy'); toast(err.message) });
});
// quick buy on cards (and the start page's engraved mug, data-eng-home)
document.addEventListener('click', e => {
  const b = e.target.closest('[data-add]'); if (!b || e.defaultPrevented) return;
  e.preventDefault();
  if (b.disabled || b.getAttribute('aria-busy') === 'true') return;
  const pr = {};
  if (b.hasAttribute('data-eng-home')) {
    // the example text is never ordered: only what was typed
    const note = engNote([($('#eName') || {}).value, ($('#eDate') || {}).value]);
    if (note) { const s = $('[data-es][aria-pressed="true"]'); pr.Gravyr = note; pr.Gravyrstil = s && s.getAttribute('data-es') === 'caps' ? 'Versaler' : 'Skrivstil' }
  }
  const extra = b.getAttribute('data-props');
  if (extra) { try { Object.assign(pr, JSON.parse(extra)) } catch(err) {} }
  b.setAttribute('aria-busy', 'true');
  add(b.getAttribute('data-variant') || b.getAttribute('data-add'), +b.getAttribute('data-qty') || 1, pr)
    .then(() => toast(pr.Gravyr ? 'Tillagd med gravyr' : 'Tillagd i varukorgen'))
    .catch(err => toast((err && err.message) || 'Det gick inte att lägga i varukorgen.'))
    .finally(() => b.removeAttribute('aria-busy'));
});
/* Dawn's cart page (/cart) changes one line at a time, so there an engraving fee line can lose its piece: the piece
   removed or its quantity changed, or the fee line removed on its own. After every change there the cart is put
   right, as the drawer keeps it: each fee line has its piece's quantity (0 without the piece), and an engraved piece
   whose fee line is gone gets it back. Then the page reloads, so Dawn's sections show the result. */
let mending = false;
function mendFees(c){
  const f = feeOf(); if (!f || mending || !c || !c.items) return;
  const pieces = {}, fees = {};
  c.items.forEach(it => { const id = props(it)._gravyr_id; if (id) (isFee(it) ? fees : pieces)[id] = it });
  const updates = {}, lost = [];
  Object.keys(fees).forEach(id => { const want = pieces[id] ? pieces[id].quantity : 0; if (fees[id].quantity !== want) updates[fees[id].key] = want });
  Object.keys(pieces).forEach(id => { const it = pieces[id]; if (!fees[id] && props(it).Gravyr) lost.push({id:+f.v, quantity:it.quantity, properties:{Till:SV[it.handle] || it.product_title, _gravyr_id:id}}) });
  if (!Object.keys(updates).length && !lost.length) return;
  mending = true;
  let changed = false;
  const step1 = Object.keys(updates).length ? api(R.cart_update + '.js', {updates:updates}).then(() => { changed = true }) : Promise.resolve();
  // a fee that cannot be added back (sold out, removed) is left to the shop, as when the piece was first added
  step1.then(() => lost.length ? api(R.cart_add + '.js', {items:lost}).then(() => { changed = true }, () => {}) : null)
    .then(() => { if (changed) location.reload(); else mending = false }, () => { mending = false });
}
try {
  if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') window.subscribe(PUB_SUB_EVENTS.cartUpdate, () => { refresh(true).then(mendFees).catch(() => {}) });
} catch(e) {}
// back/forward cache: the cart may have changed on another page
window.addEventListener('pageshow', e => { if (e.persisted) refresh(true).catch(() => {}) });

/* ---------- copy + opening hours ---------- */
document.addEventListener('click', e => {
  const b = e.target.closest('[data-copy]'); if (!b) return;
  const done = t => { b.textContent = t; setTimeout(() => { b.textContent = 'Kopiera' }, 1800) };
  const select = () => { const r = document.createRange(); r.selectNodeContents(b.previousElementSibling); const s = getSelection(); s.removeAllRanges(); s.addRange(r); done('Markerat') };
  if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(b.getAttribute('data-copy')).then(() => done('Kopierat'), select);
  else select();
});
// opening hours from the theme settings: weekdays, Saturday, Sunday ("Stängt" = closed), and an optional summer schedule
// "10.00–18.00" -> [600, 1080] minutes; anything without times (Stängt) -> null, a closed day
const span = s => { const m = String(s || '').match(/(\d{1,2})(?:[.:](\d{2}))?\s*[–—-]\s*(\d{1,2})(?:[.:](\d{2}))?/); return m ? [m[1] * 60 + +(m[2] || 0), m[3] * 60 + +(m[4] || 0)] : null };
const HRS = S.hours || {}, SUM = HRS.summer || {};
const hhmm = m => Math.floor(m / 60) + '.' + String(m % 60).padStart(2, '0');
const DAYNAME = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];
// the schedule in force on a Stockholm date ("MM-DD"): summer between from and to (inclusive) when switched on
function schedule(md){
  const inSummer = SUM.on && /^\d\d-\d\d$/.test(SUM.from || '') && /^\d\d-\d\d$/.test(SUM.to || '') &&
    (SUM.from <= SUM.to ? md >= SUM.from && md <= SUM.to : md >= SUM.from || md <= SUM.to);
  const src = inSummer ? SUM : HRS;
  return {summer: inSummer, wk: src.wk, sa: src.sa, su: src.su};
}
const dayKey = d => d === 0 ? 'su' : d === 6 ? 'sa' : 'wk';
function stockholm(t){
  const p = {}; new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Stockholm', year:'numeric', month:'2-digit', day:'2-digit', weekday:'short', hour:'2-digit', minute:'2-digit', hour12:false}).formatToParts(t).forEach(x => { p[x.type] = x.value });
  return {md: p.month + '-' + p.day, dow: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday), mins: (+p.hour % 24) * 60 + (+p.minute)};
}
function updateOpen(){
  const now = stockholm(new Date()), sch = schedule(now.md), today = span(sch[dayKey(now.dow)]);
  const open = !!today && now.mins >= today[0] && now.mins < today[1];
  let txt;
  if (open) txt = `Öppet nu · stänger ${hhmm(today[1])}`;
  else if (today && now.mins < today[0]) txt = `Stängt · öppnar ${hhmm(today[0])}`;
  else {   // the next day the shop opens: "i morgon", or the weekday's name
    txt = 'Stängt';
    for (let k = 1; k <= 7; k++) { const d = stockholm(new Date(Date.now() + k * 864e5)), h = span(schedule(d.md)[dayKey(d.dow)]);
      if (h) { txt = `Stängt · öppnar ${hhmm(h[0])} ${k === 1 ? 'i morgon' : 'på ' + DAYNAME[d.dow]}`; break } }
  }
  $$('[data-open-text]').forEach(e => { e.textContent = txt });
  $$('[data-open-dot]').forEach(e => e.classList.toggle('open', open));
  $$('.hours tr[data-day]').forEach(r => r.classList.toggle('today', r.getAttribute('data-day') === dayKey(now.dow)));
  if (sch.summer) {   // in summer the tables show the summer times
    $$('[data-hours]').forEach(c => { const v = sch[c.getAttribute('data-hours')]; if (v) c.textContent = v });
    const short = v => String(v || '').replace(/[.:]00/g, '').replace(/^Stängt$/i, 'stängt');
    $$('[data-hours-line]').forEach(p => { const tail = p.innerHTML.split('<br>').slice(1).join('<br>'); p.innerHTML = `Vardagar ${short(sch.wk)} · Lördag ${short(sch.sa)} · Söndag ${short(sch.su)}` + (tail ? '<br>' + tail : '') });
  }
}

/* ---------- links to the page you are already on: close the menu and briefly light up what was asked for ---------- */
const isHome = () => S.template === 'index';
function flash(key){
  if (!key) return;
  if (key === 'top' && isHome()) { window.scrollTo({top:0, behavior:REDUCED ? 'auto' : 'smooth'}); return }
  const k = String(key).replace(/["\\]/g, '');
  const el = document.querySelector(`[data-flash-target~="${k}"]`) || document.querySelector('main .phead');
  if (!el) return;
  reveal(el);
  el.classList.remove('flash'); void el.offsetWidth; el.classList.add('flash');
  clearTimeout(el._ft); el._ft = setTimeout(() => el.classList.remove('flash'), 2800);
}
function scrollToId(id){
  const el = document.getElementById(id);
  if (el) setTimeout(() => reveal(el), 60);
}
// centred on the screen; something taller than the space under the sticky header starts at its top instead (the sell
// page's calculator on a phone), so its heading is never hidden under the header
function reveal(el){
  const hdr = ($('header.site') || {}).offsetHeight || 0, tall = el.getBoundingClientRect().height > innerHeight - hdr - 40;
  el.scrollIntoView({behavior:REDUCED ? 'auto' : 'smooth', block:tall ? 'start' : 'center'});
}
// a flash or scroll asked for on the way to another page waits there in sessionStorage
const setPending = (k, v) => { try { sessionStorage.setItem(k, v) } catch(e) {} };
const takePending = k => { try { const v = sessionStorage.getItem(k); sessionStorage.removeItem(k); return v } catch(e) { return null } };
const samePath = (a, b) => a.replace(/\/+$/, '') === b.replace(/\/+$/, '');
document.addEventListener('click', e => {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  const a = e.target.closest('a[href]');
  if (!a || a.target === '_blank' || a.hasAttribute('download') || e.target.closest('[data-add]')) return;
  let u; try { u = new URL(a.href, location.href) } catch(err) { return }
  if (u.origin !== location.origin) return;
  const here = samePath(u.pathname, location.pathname) && u.search === location.search;
  const metal = a.getAttribute('data-setmetal'), to = a.getAttribute('data-to'), fl = a.getAttribute('data-flash');
  if (metal) {
    try { localStorage.setItem('lg-metal', metal) } catch(err) {}
    document.dispatchEvent(new CustomEvent('lg:metal', {detail:metal}));
  }
  if (to) {
    if (here) { e.preventDefault(); closeAll(); scrollToId(to) } else setPending('lg-to', to);
    return;
  }
  if (a.closest('.card,.gift,.ix,.row,.crumbs')) return;
  // a link to the section the address already names (#smycken after the first click) scrolls there again;
  // only a link without a hash lights up the page (or goes to the top of the start page)
  if (here && u.hash && u.hash === location.hash && !fl) {
    let t = null; try { t = document.getElementById(decodeURIComponent(u.hash.slice(1))) } catch(err) {}
    if (t) { e.preventDefault(); closeAll(); t.scrollIntoView({behavior:REDUCED ? 'auto' : 'smooth', block:'start'}); return }
  }
  if (here && (!u.hash || u.hash === location.hash)) { e.preventDefault(); closeAll(); flash(fl || 'top') }
  else if (here) closeAll();
  else if (fl) setPending('lg-flash', fl);
}, true);

/* ---------- header, panels and keys ---------- */
document.addEventListener('click', e => {
  const t = e.target;
  const mb = t.closest('[data-mega]');
  if (mb) { const k = mb.getAttribute('data-mega'); if (megaKey === k) closeMega(); else openMega(k); return }
  if (megaKey && !t.closest('[data-mega-panel]')) closeMega();
  const plain = !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
  if (t.closest('#menuBtn')) { openPanel($('#mmenu')); return }
  if (plain && t.closest('#searchBtn') && $('#search')) { e.preventDefault(); openSearch(); return }
  if (plain && t.closest('#cartBtn') && cartEl && S.template !== 'cart') { e.preventDefault(); openCart(); return }
  if (t === scrim || t.closest('[data-close]')) closePanel();
});
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  if (megaKey && !openEl) { const b = $(`[data-mega="${megaKey}"]`); closeMega(); if (b) b.focus(); return }
  closePanel();
});

/* ---------- the lamp: velvet stages follow the pointer ---------- */
if (FINE) document.addEventListener('pointermove', e => {
  const s = e.target.closest && e.target.closest('[data-spot]'); if (!s) return;
  const r = s.getBoundingClientRect();
  s.style.setProperty('--mx', (e.clientX - r.left) + 'px'); s.style.setProperty('--my', (e.clientY - r.top) + 'px');
}, {passive:true});

/* ---------- boot: after every deferred script (lg-3d.js, page scripts) has run ---------- */
let annTimer = 0;
function rotateAnnouncements(){
  // phones show one announcement at a time
  clearInterval(annTimer);
  if (REDUCED || !matchMedia('(max-width:520px)').matches) return;
  annTimer = setInterval(() => {
    if (document.hidden) return;
    const an = $$('.announce .wrap>span'); if (an.length < 2) return;
    const i = Math.max(0, an.findIndex(x => x.classList.contains('on')));
    an[i].classList.remove('on'); an[(i + 1) % an.length].classList.add('on');
  }, 4200);
}
function textFixes(root){
  $$('[data-free]', root).forEach(e => { if (!e.textContent.trim()) e.textContent = fmt(S.free) });
  // texts written in the Shopify admin (policies, pages) keep their empty lines as paragraphs holding only a no-break
  // space, which print as large gaps
  $$('.shopify-policy__body .rte>p, .lg-rte>p', root).forEach(p => { if (!p.textContent.replace(/\u00a0/g, ' ').trim() && !p.querySelector('img,iframe,video,svg')) p.remove() });
  // touch screens read "Tryck…" where a mouse reads "Klicka…" (the showroom words its own help)
  if (!FINE) $$('[data-touch]', root).forEach(e => { if (!e.closest('.room')) e.textContent = e.getAttribute('data-touch') });
}
let booted = false;
function boot(){
  if (booted) return; booted = true;
  readIslands(); collect();
  updateOpen(); setInterval(updateOpen, 60000);
  textFixes(document);
  rotateAnnouncements();
  hydrate(document);
  const pf = takePending('lg-flash'); if (pf) setTimeout(() => flash(pf), 380);
  const pt = takePending('lg-to'); if (pt) setTimeout(() => scrollToId(pt), 380);
}
if (document.readyState === 'complete') boot();
else { document.addEventListener('DOMContentLoaded', boot); window.addEventListener('load', boot) }
// the theme editor re-renders sections in place
document.addEventListener('shopify:section:load', e => { readIslands(e.target); collect(e.target); updateOpen(); textFixes(e.target); rotateAnnouncements(); hydrate(e.target) });

/* ---------- public ---------- */
Object.assign(LG, {
  $:$, $$:$$, esc:esc, REDUCED:REDUCED, FINE:FINE, icons:{arr:ICON_ARR, plus:ICON_PLUS, shard:SHARD},
  COLS:COLS, GROUPS:GROUPS, DOP:DOP, SHORT:SHORT, colFor:colFor, metalOf:metalOf, SV:SV, ENGRAVABLE:ENGRAVABLE,
  title:title, hallmark:hallmark, stamp:stamp, money:money, fmt:fmt, sized:sized, card:card,
  register:register, collect:collect, hydrate:hydrate, load:load, engine:engine,
  cart:{add:add, open:openCart, refresh:() => refresh(true), get:() => CART, render:renderCart},
  toast:toast, openPanel:openPanel, closePanel:closePanel, closeAll:closeAll, flash:flash, updateOpen:updateOpen
});
})();
